import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import { useLocation, useParams, useNavigate  } from "react-router-dom";
import airlines from "../data/airlines.json";
import airportsData from '../data/airports.json';
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Icons from react-icons
import { FaRunning } from "react-icons/fa";
import { CiClock2 } from "react-icons/ci";
import { FaPlaneDeparture } from "react-icons/fa";
import { PiSeatLight } from "react-icons/pi";

function FlightDetail() {

  const phoneNumber = "+923454362491";

  // Toggle function for flight details
  const [openFlightIndex, setOpenFlightIndex] = useState(null); // Track state for each flight
  const [selectedAirlines, setSelectedAirlines] = React.useState([]);

  // Toggle function for flight details visibility
  const toggleDetails = (index) => {
    setOpenFlightIndex((prevIndex) => (prevIndex === index ? null : index)); // Close if same flight is clicked again
  };

  const [token, setToken] = useState("");
  const [flights, setFlights] = useState([]);
  const [loading, setLoading] = useState(true);
  const { search } = useLocation();

  // Function to get the airline name by code
  const getAirlineName = (code) => {
    const airline = airlines.find((airline) => airline.code === code);
    return airline ? airline.name : "Unknown Airline";
  };

  // Define the date formatting function BEFORE using it
  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  const formatDsiplayDate = (dateStr) => {
    const date = new Date(dateStr);
    // Get the day, month, and year
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-GB", { month: "short" }); // e.g., "Oct"
    const year = date.getFullYear();

    // Construct the formatted date string
    return `${day} ${month}, ${year}`;
  };

  const extractTime = (timestamp) => {
    const date = new Date(timestamp);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const formatDuration = (duration) => {
    const regex = /PT(\d+H)?(\d+M)?/; // Regex to extract hours and minutes
    const match = duration.match(regex);

    const hours = match[1] ? match[1].replace("H", "") : "0";
    const minutes = match[2] ? match[2].replace("M", "") : "0";

    return `${hours}h ${minutes}min`;
  };


  {/*Destination Page values Start*/}
  const { 'from-to': fromTo } = useParams(); // Access the combined parameter
  let toAirport, startDateDestination, EndDateDestination,startDate, endDate  = '';

  if (fromTo) {
      // Split the parameter to get from and to
      const [from, to] = fromTo.split('-to-');
      //Get Airport Code By City
      const getAirportCodeByCity = (city) => {
          const airport = airportsData.find(airport => airport.name.includes(city));
          return airport ? airport.code : 'Airport code not found';
      };
      toAirport = getAirportCodeByCity(to.replace(/-/g, ' '));

      // Helper function to format dates as DD-MM-YYYY
      const formatDestinationDate = (date) => {
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
          const year = date.getFullYear();
          return `${year}-${month}-${day}`;
      };

      // Calculate the start date (3 days from the current date)
      const currentDate = new Date();
      const startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() + 3);
      startDateDestination = formatDestinationDate(startDate);

      // Calculate the return date (10 days after the start date)
      const returnDate = new Date(startDate);
      returnDate.setDate(startDate.getDate() + 10);
      EndDateDestination = formatDestinationDate(returnDate);

  }
  {/*Destination Page values End*/}

  // Extract query parameters from the URL
  const queryParams = new URLSearchParams(window.location.search);
  const origin = queryParams.get("origin") || "LHR";
  const destination = queryParams.get("destination") || toAirport;
  const tripType = queryParams.get("tripType") || 'Round Trip'; // e.g., 'one-way' or 'round-trip'
  
  if (fromTo) {
    startDate = startDateDestination;
    endDate = EndDateDestination;
  }else{
    startDate = formatDate(queryParams.get("startDate"));
    endDate = queryParams.get("endDate")
      ? formatDate(queryParams.get("endDate"))
      : null;
  }
  const adults = queryParams.get("adults") || 1;
  const children = queryParams.get("children") || 0;
  const infants = queryParams.get("infants") || 0;
  const flightClass = queryParams.get("flightClass") || 'ECONOMY';
  const name = queryParams.get("name");
  const email = queryParams.get("email");
  const phone = queryParams.get("phone");


  // Construct the API URL dynamically based on query parameters
  const apiUrl = `https://test.api.amadeus.com/v2/shopping/flight-offers?originLocationCode=${origin}&destinationLocationCode=${destination}&departureDate=${startDate}&adults=${adults}&children=${children}&infants=${infants}&travelClass=${flightClass}&nonStop=false&currencyCode=GBP&max=35${
    tripType === "Round Trip" ? `&returnDate=${endDate}` : ""
  }`;

  // Step 1: Fetch Access Token (Once on Mount)
  useEffect(() => {
    const getAccessToken = async () => {
      try {
        const response = await axios.post(
          "https://test.api.amadeus.com/v1/security/oauth2/token",
          new URLSearchParams({
            grant_type: "client_credentials",
            client_id: "ME9mKYMWwxzf3JI02aTa5bHDh8DgLZXo",
            client_secret: "M9QzUQhuxMAXstqK",
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        );

        setToken(response.data.access_token);
      } catch (error) {
        //console.error("Error fetching token:", error);
      }
    };

    getAccessToken(); // Call only once on mount
  }, []); // Empty dependency to run only on initial render

  // Step 2: Fetch Flight Offers (Only After Token Is Ready)
  useEffect(() => {
    if (!token) return; // Prevent fetching without token
   
    const fetchFlightOffers = async () => {
      try {
        setLoading(true);
        setFlights([]);
        const response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Flight Data:", response.data); // Single call, no double log
        setFlights(response.data.data || []);
      } catch (error) {
        //console.error("Error fetching flight offers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFlightOffers(); // Triggered only once after token is set
  }, [token, apiUrl]); // Run when token changes

  // Helper function to calculate time difference
  const calculateTimeDifference = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const differenceInMs = endDate - startDate; // Difference in milliseconds

    // Convert milliseconds to hours and minutes
    const hours = Math.floor(differenceInMs / (1000 * 60 * 60));
    const minutes = Math.floor(
      (differenceInMs % (1000 * 60 * 60)) / (1000 * 60)
    );

    return `${hours}h ${minutes}m`;
  };

  {
    /*Horizontal Arrow*/
  }
  const FlightStopsArrowHorizontal = (totalStopss) => {
    return (
      <div>
        <div className="TransportTimeline__LineWrapper">
          <div className="TransportTimeline__Line"></div>
          <div className="TransportTimeline__Triangle"></div>
          <div className="TransportTimeline__Dots">
            {Array.from({ length: totalStopss }).map((_, index) => (
              <div className="TransportTimeline__Dot"></div>
            ))}
          </div>
        </div>
        <small className="stops-text">
          {totalStopss === 0
            ? "Direct"
            : `${totalStopss} ${totalStopss === 1 ? "stop" : "stops"}`}
        </small>
      </div>
    );
  };

  {/*AIrline Filter Function*/}
  const filteredAirlines = useMemo(() => {
    const flightCodes = flights
      .map((flight) => {
        const itineraries = flight.itineraries;
        const segments = itineraries
          .map((itineray) => itineray.segments)
          .flat();
        const carrierCodes = (segments || []).map(
          (segment) => segment.carrierCode
        );
        return carrierCodes;
      })
      .flat();
    return [...new Set(flightCodes.map((code) => getAirlineName(code)))];
  }, [flights]);

    const handleCheckboxChange = (airline) => {
    setSelectedAirlines((prevSelected) =>
      prevSelected.includes(airline)
        ? prevSelected.filter((item) => item !== airline)
        : [...prevSelected, airline]
    );
  };

  const resetFilter = () => {
    setSelectedAirlines([]);
  };

  const flightsToDisplay = selectedAirlines.length > 0
    ? flights.filter((flight) =>
        flight.itineraries.some((itinerary) =>
          itinerary.segments.some((segment) =>
            selectedAirlines.includes(getAirlineName(segment.carrierCode))
          )
        )
      )
    : flights; // Show all flights if no airline is selected

  /*Booking FUnction*/
  const navigate = useNavigate();
  const handleInquireClick = async (selectedFlight) => {

        const savedData = JSON.parse(localStorage.getItem('flightFormData'));

        // Save the selected flight in localStorage
        localStorage.setItem("selectedFlightairline", getAirlineName(selectedFlight.validatingAirlineCodes[0]));
        localStorage.setItem("selectedFlightPrice", selectedFlight.price.total);
        localStorage.setItem("selectedFlight", JSON.stringify(selectedFlight));
        
        const formData = {
            "tripType":savedData.tripType,
            "originFullName":savedData.originFullName,
            "destinationFullName":savedData.destinationFullName,
            "startDate": savedData.startDate,
            "endDate": savedData.endDate,
            "adults": savedData.adults,
            "children": savedData.children,
            "infants": savedData.infants,
            "username":savedData.username,
            "useremail":savedData.useremail,
            "phonenumber":savedData.phonenumber,
            "selectedFlight":getAirlineName(selectedFlight.validatingAirlineCodes[0]),
            "selectedPrice":selectedFlight.price.total
        };
        
         try {
              const response = await fetch('https://7skyseo.com/holiday-expert-server-side-files/search-detail-inquiry.php', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
              });
          } catch (error) {
              console.error('Error:', error);
          }

        

    // Navigate to the booking page and pass selected flight details as state
    navigate('/booking', { state: { selectedFlight } });
  };

   // Function to get the airport name by code
  const getAirportName = (code) => {
    const airport = airportsData.find(airport => airport.code === code);
    return airport ? airport.name : 'Airport not found';
  };

  const handleShare = () => {
    const currentUrl = window.location.href; // Get the current URL
    const message = `Check this out: ${currentUrl}`; // Message to share
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

    // Open the WhatsApp share link
    window.open(whatsappUrl, "_blank");
  };

  {/*onClick={() => {
    const shareText = `Check out this flight: ${getAirportName(origin)} - ${getAirportName(destination)}, Date: ${startDate} - ${endDate}, Airline: ${getAirlineName(flight.validatingAirlineCodes[0])}, Price: £${flight.price?.total}`;
    if (navigator.share) {
      navigator.share({
        title: "Flight Details",
        text: shareText,
        url: window.location.href, // You can replace this with a flight-specific URL
      });
    } else {
      alert("Sharing not supported on this browser.");
    }
  }}*/}
  return (
    <>
      {/* top Destination starts */}
      <section className="resultsSections pt-6 pb-5" >
        <div className="container">
          {loading ? (
            <div className="text-center loadingIcon">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/loader.gif`}
                alt="loader"
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-lg-3 ps-lg-3 hidden-mobile">
                <div className="sidebar-sticky">
                  <div className="list-sidebar">
                    
                    <div className="sidebar-item mb-4">
                      <h3 className="">Airlines</h3>
                      <ul className="sidebar-category1">
                        {(filteredAirlines || []).map((airline) => (
                          <li key={airline}>
                             <label className="filterCheck">
                              <input
                                type="checkbox"
                                value={airline}
                                checked={selectedAirlines.includes(airline)}
                                onChange={() => handleCheckboxChange(airline)}
                              />&nbsp;
                              {airline}
                          </label>
                          </li>
                        ))}
                      </ul>
                      <button onClick={resetFilter} style={{ marginTop: "10px" }} className="nir-btn-black">
                        Reset Filter
                      </button>
                    </div>

                    <div className="sidebar-item bg-white rounded box-shadow overflow-hidden p-3 mb-4">
                            <h4>Why booking with us?</h4>
                            <div className="sidebar-module-inner">
                                <ul className="featured-list-sm">
                                    <li className="border-b pb-2 mb-2">
                                        <h6 className="mb-0">No Booking Charges</h6>
                                        We don't charge you an extra fee for booking a hotel room with us
                                    </li>
                                    <li className="border-b pb-2 mb-2">
                                        <h6 className="mb-0">No Cancellation Sees</h6>
                                        We don't charge you a cancellation or modification fee in case plans change
                                    </li>
                                    <li className="border-b pb-2 mb-2">
                                        <h6 className="mb-0">Instant Confirmation</h6>
                                        Instant booking confirmation whether booking online or via the telephone
                                    </li>
                                    <li>
                                        <h6 className="mb-0">Flexible Booking</h6>
                                        You can book up to a whole year in advance or right up until the moment of your stay
                                    </li>
                                </ul>
                            </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <div className="flight-list">

                  <div className="call-section">
                    <div className="call-text">
                      <h2>Call Us Now for Family Deals and Exclusive Discounts!</h2>
                      <a href="tel:02071832321" className="call-btn">
                        📞 0207 183 2321
                      </a>
                    </div>
                  </div>

                  <div className="flight-full">
                    {flightsToDisplay.map((flight, flightIndex) => {
                      // Group traveler pricings by type inside each flight
                      const groupedTravelerPricings =
                        flight.travelerPricings.reduce((acc, traveler) => {
                          const type =
                            traveler.travelerType === "HELD_INFANT"
                              ? "Infant"
                              : traveler.travelerType; // Replace "HELD_INFANT" with "Infant"

                          if (!acc[type]) {
                            acc[type] = { quantity: 0, totalPrice: 0 };
                          }

                          acc[type].quantity += traveler.quantity || 1; // Sum quantities
                          acc[type].totalPrice += parseFloat(
                            traveler.price.total
                          ); // Sum prices

                          return acc;
                        }, {});

                      // Initialize a variable to collect segment details during the itinerary loop
                      let segmentDetails = [];
                      return (
                        <div
                          key={flightIndex} >
                        <div  className="flightRow item mb-2 p-3 px-4 rounded" >
                        
                          <div className="row d-flex align-items-center justify-content-between">
                            <div className="col-lg-10">
                              {flight.itineraries.map(
                                (itinerary, itineraryIndex) => {
                                  //Total Stops Calculate
                                  const segments = itinerary.segments;
                                  const totalStops = segments.length - 1; // Number of stops is one less than the number of segments

                                  // Extract start and end times for each itinerary
                                  const firstSegment = itinerary.segments[0];
                                  const lastSegment =
                                    itinerary.segments[
                                      itinerary.segments.length - 1
                                    ];
                                  const startTime = extractTime(
                                    firstSegment.departure.at
                                  );
                                  const endTime = extractTime(
                                    lastSegment.arrival.at
                                  );
                                  const startDate = formatDsiplayDate(
                                    firstSegment.departure.at
                                  );
                                  const EndDate = formatDsiplayDate(
                                    lastSegment.arrival.at
                                  );
                                  const duration = formatDuration(
                                    itinerary.duration
                                  );

                                  //Origin Destination Names
                                  const originName =
                                    firstSegment.departure.iataCode;
                                  const destinationName =
                                    lastSegment.arrival.iataCode;

                                  // Airline details for the first segment of each itinerary
                                  const airlineCode = firstSegment.carrierCode;
                                  const airlineName =
                                    getAirlineName(airlineCode);
                                  const flightNumber = firstSegment.number;

                                  // Collect segment details for Flight Details button
                                  segmentDetails.push(
                                    <div
                                      key={itineraryIndex}
                                      className="mb-3 segmentBox"
                                    >
                                      <h6>
                                        <FaPlaneDeparture /> {originName} -{" "}
                                        {destinationName}
                                      </h6>

                                      {itinerary.segments.map(
                                        (segment, segmentIndex) => {
                                          const airlineName = getAirlineName(
                                            segment.carrierCode
                                          );
                                          const departureTime = extractTime(
                                            segment.departure.at
                                          );
                                          const arrivalTime = extractTime(
                                            segment.arrival.at
                                          );
                                          const departureDate =
                                            formatDsiplayDate(
                                              segment.departure.at
                                            );
                                          const arrivalDate = formatDsiplayDate(
                                            segment.arrival.at
                                          );

                                          let timeDifference = "";
                                          if (
                                            segmentIndex <
                                            segments.length - 1
                                          ) {
                                            const nextSegment =
                                              segments[segmentIndex + 1];
                                            timeDifference =
                                              calculateTimeDifference(
                                                segment.arrival.at,
                                                nextSegment.departure.at
                                              );
                                          }

                                          return (
                                            <div
                                              className="row text-center"
                                              key={segmentIndex}
                                            >
                                              <div className="col-lg-3 sgAirline">
                                                <div className="item-inner-image">
                                                  <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/airline/${segment.carrierCode}.png`}
                                                    alt="image"
                                                    className="resultPlane"
                                                  />
                                                  <h5 className="mb-0 airlineName">
                                                    {airlineName}
                                                  </h5>
                                                  <small>
                                                    {segment.carrierCode}{" "}
                                                    {segment.number}
                                                  </small>
                                                </div>
                                              </div>

                                              <div className="col-lg-2 sgFlightTime">
                                                <div className="item-inner">
                                                  <div className="content">
                                                    <h3 className="mb-0 flightTime">
                                                      {departureTime}
                                                    </h3>
                                                    <small className="mb-0 text-uppercase">
                                                      {
                                                        segment.departure
                                                          .iataCode
                                                      }
                                                    </small>
                                                    <br />
                                                    <small className="mb-0 text-uppercase">
                                                      {departureDate}
                                                    </small>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-lg-2 sgFlightDuration">
                                                <div className="item-inner flight-time">
                                                  <small className="mb-0">
                                                    <CiClock2 />
                                                    <br />
                                                    {formatDuration(
                                                      segment.duration
                                                    )}
                                                  </small>
                                                </div>
                                              </div>
                                              <div className="col-lg-2 sgFlightTime">
                                                <div className="item-inner">
                                                  <div className="content">
                                                    <h3 className="mb-0 flightTime">
                                                      {arrivalTime}
                                                    </h3>
                                                    <small className="mb-0 text-uppercase">
                                                      {segment.arrival.iataCode}
                                                    </small>
                                                    <br />
                                                    <small className="mb-0 text-uppercase">
                                                      {arrivalDate}
                                                    </small>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-lg-1 col-md-2 col-sm-12 sgEconomy">
                                                <div className="item-inner flight-time">
                                                  <small className="mb-0">
                                                    <PiSeatLight />
                                                    <br />
                                                    Economy
                                                  </small>
                                                </div>
                                              </div>
                                              <div className="col-lg-2 col-md-2 col-sm-12 sgExtraDetails">
                                                <div className="item-inner flight-time">
                                                  <small className="mb-0">
                                                    Seat Available
                                                    <br />
                                                    Class Type
                                                    <br />
                                                    Piece Counts
                                                  </small>
                                                </div>
                                              </div>
                                              {timeDifference && (
                                                <div>
                                                  <div className="fd_line_structure">
                                                    <div className="fd_line"></div>
                                                    <div className="fd_icon_wrapper">
                                                      <p className="fd_middle_border">
                                                        <FaRunning /> Layover{" "}
                                                        {timeDifference}
                                                      </p>
                                                    </div>
                                                    <div className="fd_line"></div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  );

                                  return (
                                    <div
                                      className="row text-center itry"
                                      key={itineraryIndex}
                                    >
                                      <div className="col-lg-4 itryAirline">
                                        <div className="item-inner-image">
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/airline/${airlineCode}.png`}
                                            alt="image"
                                            className="resultPlane"
                                          />
                                          <h5 className="mb-0 airlineName">
                                            {airlineName}
                                          </h5>
                                          <small>
                                            {airlineCode} {flightNumber}
                                          </small>
                                        </div>
                                      </div>

                                      <div className="col-lg-3 itryFlightTime">
                                        <div className="item-inner">
                                          <div className="content">
                                            <h3 className="mb-0 flightTime">
                                              {startTime}
                                            </h3>
                                            <small className="mb-0 text-uppercase">
                                              {originName}
                                            </small>
                                            <br />
                                            <small className="mb-0 text-uppercase">
                                              {startDate}
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-2 itryFlightDuration">
                                        <div className="item-inner flight-time">
                                          <small className="mb-0">
                                            {duration}
                                          </small>
                                          <br />
                                          {FlightStopsArrowHorizontal(
                                            totalStops
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-3 itryFlightTime">
                                        <div className="item-inner">
                                          <div className="content">
                                            <h3 className="mb-0 flightTime">
                                              {endTime}
                                            </h3>
                                            <small className="mb-0 text-uppercase">
                                              {destinationName}
                                            </small>
                                            <br />
                                            <small className="mb-0 text-uppercase">
                                              {EndDate}
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                      {itineraryIndex === 0 && (
                                        <div
                                          className="border-t"
                                          style={{ margin: "10px 0" }}
                                        ></div>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-12">
                              <div className="item-inner text-center">
                                <p className="theme2 fs-4 fw-bold">
                                  £{flight.price.total}
                                </p>

                                <div>
                                  {Object.entries(groupedTravelerPricings).map(
                                    (
                                      [type, { quantity, totalPrice }],
                                      index
                                    ) => (
                                      <small
                                        className="priceBreakDown"
                                        key={index}
                                      >
                                        {quantity} X {type}
                                        {quantity > 1 ? "s" : ""} = £
                                        {totalPrice.toFixed(2)}
                                      </small>
                                    )
                                  )}
                                </div>
                                <div>
                                <small style={{fontSize:'60%',fontStyle:'italic'}}>Prices are subject to availability of seats</small>
                                </div>
                                <button  onClick={() => handleInquireClick(flight)} className="nir-btn-black inquireBtn">
                                  Confirm Availability
                                </button>
                                      
                                {/* Buttons */}
                                <div className="flight-actions">
                                  {/* Share Button */}
                                  <button
                                    onClick={() => {
                                      const shareText = `Check this out: `;
                                      if (navigator.share) {
                                        navigator.share({
                                          title: "Flight Details",
                                          text: shareText,
                                          url: window.location.href, // You can replace this with a flight-specific URL
                                        });
                                      } else {
                                        alert("Sharing not supported on this browser.");
                                      }
                                    }}
                                    className="action-button share-button"
                                  >
                                    <i className="fas fa-share-alt"></i>
                                  </button>

                                  {/* WhatsApp Button */}
                                  <a
                                    href={`https://wa.me/${phoneNumber}?text=I'm interested in this flight: ${getAirportName(origin)} - ${getAirportName(destination)}, Date: ${startDate} - ${endDate}, Airline: ${getAirlineName(flight.validatingAirlineCodes[0])}, Price: £${flight.price?.total}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="action-button whatsapp-button"
                                  >
                                    <i className="fab fa-whatsapp"></i>
                                  </a>

                                  {/* Call Button */}
                                  <a href={`tel:${phoneNumber}`} className="action-button call-button">
                                    <i className="fas fa-phone"></i>
                                  </a>
                                  
                                </div>   

                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-4 text-center">
                              {/*Detail of Flight On Click Start*/}
                              <p
                                className="flightDetailBtn"
                                onClick={() => toggleDetails(flightIndex)}
                              >
                                {openFlightIndex === flightIndex ? (
                                  <>
                                    Hide Flight Details <FaChevronUp />
                                  </>
                                ) : (
                                  <>
                                    Show Flight Details <FaChevronDown />
                                  </>
                                )}
                              </p>
                            </div>
                          </div>
                          <div className="row segment">
                            <div className="col-lg-12">
                              {/* Flight Details (Visible only when toggled) */}
                              {openFlightIndex === flightIndex && (
                                <div className="flight-details mt-3">
                                  {segmentDetails}
                                </div>
                              )}
                              {/*Detail of Flight On Click End*/}
                            </div>
                          </div>
                          </div>
                          {flightIndex === 0 && (
                            <div class="call-to-action">
                                <p>Need help finding the best deal?</p>
                                <a href="tel:02071832321" class="call-now-btn">📞 Call Us Now for Expert Advice!</a>
                            </div>
                          )}
                        </div>

                        
                      );
                      
                    })}
                  </div>
                  {/*<div className="flight-btn text-center"><a href="#" className="nir-btn">Load More</a></div>*/}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      {/* top Destination ends */}
    </>
  );
}
export default FlightDetail;
